import styled, { CSSProp } from 'styled-components';
import { pxToRem } from 'src/common/utils/helpers';

export interface BaseProps {
  css?: CSSProp;
  display?: string;
  boxSizing?: string;
  width?: string;
  fontSize?: string;
  height?: string;
  minHeight?: string;
  minWidth?: string;
  maxHeight?: string;
  maxWidth?: string;
  flex?: number;
  flexWrap?: string;
  flexDirection?: string;
  flexGrow?: number;
  padding?: string;
  margin?: string;
  backgroundColor?: string;
  background?: string;
  gap?: string;
  color?: string;
  border?: string;
  borderRadius?: string;
  overflow?: string;
  overflowX?: string;
  overflowY?: string;
  boxShadow?: string;
  justifyContent?: string;
  alignItems?: string;
  alignContent?: string;
  alignSelf?: string;
  animation?: string;
  backfaceVisibility?: string;
  backgroundAttachment?: string;
  backgroundImage?: string;
  backgroundOrigin?: string;
  hoverWidth?: string;
  hoverHeight?: string;
  hoverPadding?: string;
  hoverMargin?: string;
  hoverBackgroundColor?: string;
  backgroundPosition?: string;
  hoverBackground?: string;
  borderCollapse?: string;
  columns?: string;
  borderColor?: string;
  hoverColor?: string;
  hoverBorder?: string;
  borderWidth?: string;
  opacity?: string;
  borderStyle?: string;
  hoverBorderRadius?: string;
  float?: string;
  cursor?: string;
  outline?: string;
  content?: string;
  hoverBoxShadow?: string;
  direction?: string;
  position?: string;
  flexFlow?: string;
  top?: string;
  transform?: string;
  bottom?: string;
  left?: string;
  right?: string;
  resize?: string;
  borderTop?: string;
  borderBottom?: string;
  visibility?: string;
  transition?: string;
  order?: number;
  borderLeft?: string;
  borderRight?: string;
  zIndex?: string;
  textDecoration?: string;
  onClick?: Function;
}

export const Base = styled.div<BaseProps>`
  user-select: auto;
  ${(props) => props.alignItems && `align-items: ${props.alignItems};`}
  ${(props) => props.alignContent && `align-content: ${props.alignContent};`}
  ${(props) => props.alignSelf && `align-self: ${props.alignSelf};`}
  ${(props) => props.animation && `animation: ${props.animation};`}
  ${(props) => props.backfaceVisibility && `backface-visibility: ${props.backfaceVisibility};`}
  ${(props) => props.background && `background: ${props.background};`}
  ${(props) =>
    props.backgroundAttachment && `background-attachment: ${props.backgroundAttachment};`}
  ${(props) => props.backgroundColor && `background-color: ${props.backgroundColor};`}
  ${(props) => props.backgroundImage && `background-image: ${props.backgroundImage};`}
  ${(props) => props.backgroundOrigin && `background-origin: ${props.backgroundOrigin};`}
  ${(props) => props.backgroundPosition && `background-position: ${props.backgroundPosition};`}
  ${(props) => props.border && `border: ${props.border};`}
  ${(props) => props.borderBottom && `border-bottom: ${props.borderBottom};`}
  ${(props) => props.borderCollapse && `border-collapse: ${props.borderCollapse};`}
  ${(props) => props.borderColor && `border-color: ${props.borderColor};`}
  ${(props) => props.borderLeft && `border-left: ${props.borderLeft};`}
  ${(props) => props.borderRadius && `border-radius: ${props.borderRadius};`}
  ${(props) => props.borderRight && `border-right: ${props.borderRight};`}
  ${(props) => props.borderStyle && `border-style: ${props.borderStyle};`}
  ${(props) => props.borderTop && `border-top: ${props.borderTop};`}
  ${(props) => props.borderWidth && `border-width: ${props.borderWidth};`}
  ${(props) => props.boxShadow && `box-shadow: ${props.boxShadow};`}
  ${(props) => props.boxSizing && `box-sizing: ${props.boxSizing};`}
  ${(props) => props.color && `color: ${props.color};`}
  ${(props) => props.columns && `columns: ${props.columns};`}
  ${(props) => props.content && `content: ${props.content};`}
  ${(props) => props.cursor && `cursor: ${props.cursor};`}
  ${(props) => props.direction && `direction: ${props.direction};`}
  ${(props) => props.display && `display: ${props.display};`}
  ${(props) => props.flex && `flex: ${props.flex};`}
  ${(props) => props.flexDirection && `flex-direction: ${props.flexDirection};`}
  ${(props) => props.flexFlow && `flex-flow: ${props.flexFlow};`}
  ${(props) => props.flexGrow && `flex-flow: ${props.flexGrow};`}
  ${(props) => props.flexWrap && `flex-wrap: ${props.flexWrap};`}
  ${(props) => props.float && `float: ${props.float};`}
  ${(props) => props.gap && `gap: ${props.gap};`}
  ${(props) => props.height && `height: ${props.height};`}
  ${(props) => props.minHeight && `min-height: ${props.minHeight};`}
  ${(props) => props.maxHeight && `max-height: ${props.maxHeight};`}
  ${(props) => props.width && `width: ${props.width};`}
  ${(props) => props.minWidth && `min-width: ${props.minWidth};`}
  ${(props) => props.maxWidth && `max-width: ${props.maxWidth};`}
  ${(props) => props.justifyContent && `justify-content: ${props.justifyContent};`}
  ${(props) => props.margin && `margin: ${props.margin};`}
  ${(props) => props.padding && `padding: ${pxToRem(props.padding)};`}
  ${(props) => props.opacity && `opacity: ${props.opacity};`}
  ${(props) => props.order && `order: ${props.order};`}
  ${(props) => props.outline && `outline: ${props.outline};`}
  ${(props) => props.overflow && `overflow: ${props.overflow};`}
  ${(props) => props.overflowX && `overflow-x: ${props.overflowX};`}
  ${(props) => props.overflowY && `overflow-y: ${props.overflowY};`}
  ${(props) => props.resize && `resize: ${props.resize};`}
  ${(props) => props.transform && `transform: ${props.transform};`}
  ${(props) => props.transition && `transition: ${props.transition};`}
  ${(props) => props.visibility && `visibility: ${props.visibility};`}
  ${(props) => props.position && `position: ${props.position};`}
  ${(props) => props.top && `top: ${props.top};`}
  ${(props) => props.left && `left: ${props.left};`}
  ${(props) => props.bottom && `bottom: ${props.bottom};`}
  ${(props) => props.right && `right: ${props.right};`}
  ${(props) => props.zIndex && `z-index: ${props.zIndex};`}
  ${(props) => props.css}
  :hover {
    ${(props) => props.hoverWidth && `width: ${props.hoverWidth};`}
    ${(props) => props.hoverHeight && `height: ${props.hoverHeight};`}
    ${(props) => props.hoverPadding && `padding: ${props.hoverPadding};`}
    ${(props) => props.hoverMargin && `margin: ${props.hoverMargin};`}
    ${(props) => props.hoverBackgroundColor && `background-color: ${props.hoverBackgroundColor};`}
    ${(props) => props.hoverBackground && `background: ${props.hoverBackground};`}
    ${(props) => props.hoverColor && `color: ${props.hoverColor};`}
    ${(props) => props.hoverBorder && `border: ${props.hoverBorder};`}
    ${(props) => props.hoverBorderRadius && `border-radius: ${props.hoverBorderRadius};`}
    ${(props) => props.hoverBoxShadow && `box-shadow: ${props.hoverBoxShadow};`}
  }
  `;

export const Row = styled(Base)`
  display: flex;
`;

export const RowV = styled(Row)`
  align-items: center;
`;

export const RowH = styled(Row)`
  justify-content: center;
`;

export const RowVH = styled(Row)`
  align-items: center;
  justify-content: center;
`;

export const RowFill = styled(Row)`
  flex: 1 0 auto;
`;

export const RowFillV = styled(RowFill)`
  align-items: center;
`;

export const RowFillH = styled(RowFill)`
  justify-content: center;
`;

export const RowFillVH = styled(RowFill)`
  align-items: center;
  justify-content: center;
`;

export const Col = styled(Base)`
  display: flex;
  flex-direction: column;
`;

export const ColV = styled(Col)`
  justify-content: center;
`;

export const ColH = styled(ColV)`
  align-items: center;
`;

export const ColVH = styled(Col)`
  align-items: center;
  justify-content: center;
`;

export const ColFill = styled(Col)`
  flex: 1 0 auto;
`;

export const ColFillV = styled(ColFill)`
  justify-content: center;
`;

export const ColFillH = styled(ColFill)`
  align-items: center;
`;

export const ColFillVH = styled(ColFill)`
  align-items: center;
  justify-content: center;
`;
